import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import useQuestionsTypes from '../../queries/useQuestionsTypes';
import { useSelector } from 'react-redux';
import { typesSelector } from '../../store/selectors';
import { questionsConstants } from '../../../../constants/questions.constants';
import { setTypes } from '../../store/actions';
import useFilterChange from '../../hooks/useFilterChange';
import { filterDelay } from '../../constants/common';

const SelectQuestionsTypes = ({ className }) => {
  const selectedTypes = useSelector(typesSelector);
  const [value, setValue] = useState(selectedTypes);
  const change = useFilterChange({ action: setTypes, delay: filterDelay });

  const { data: types, isFetching: isTypesFetching } = useQuestionsTypes({
    staleTime: Infinity,
  });

  const handleChange = (values) => {
    setValue(values);
    change(values);
  };

  useEffect(() => {
    setValue(selectedTypes);
  }, [selectedTypes]);

  return (
    <Select
      className={className}
      loading={isTypesFetching}
      mode="multiple"
      defaultActiveFirstOption={false}
      allowClear
      placeholder="Тема"
      value={types?.length ? value : []}
      optionFilterProp="searchtext"
      onChange={handleChange}
    >
      {types?.map((type) => (
        <Select.Option key={type.id} value={type.id} searchtext={type.name}>
          {questionsConstants.questionTypeIcon(type.id, 25)}
          <span style={{ marginLeft: '5px' }}>{type.name}</span>
        </Select.Option>
      ))}
    </Select>
  );
};

export default SelectQuestionsTypes;
